<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-10 10:04:51
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-19 11:42:38
-->
<template>
  <div>
    <el-drawer
      title="更多信息"
      :visible.sync="visibleTwo"
      @closed="closeTwo"
      :destroy-on-close="true"
      size="535px"
      :with-header="true"
    >
       <a-spin :spinning="appLoading">
    <div class="applay-box">
      <div>
        <div class="title">
          <div class="icon-title"></div>
          <div class="title-txt">稿件信息</div>
        </div>
        <div class="txt-box">
        <div class="txt">稿件标题</div>
        <div class="txt-two">
           {{itemData.title}}
        </div>
      </div>
        <div class="txt-box">
        <div class="txt">创作人员</div>
        <div class="txt-two">{{itemData.createName}}</div>
      </div>
      
       <div class="txt-box">
        <div class="txt">创作时间</div>
        <div class="txt-two">
         {{itemData.createTime}}
        </div>
      </div>
    </div>
    <div>
        <div class="title">
          <div class="icon-title"></div>
          <div class="title-txt">推送信息</div>
        </div>
        <div class="txt-box">
        <div class="txt">报送状态</div>
        <div class="txt-two">
            {{itemData.submitState==1?'未报送':'已报送'}}
        </div>
      </div>
        <div class="txt-box">
        <div class="txt">报送方式</div>
        <div class="txt-two">{{itemData.type==1?'栏目推送':itemData.type==2?'约稿':'新增报送'}}</div>
      </div>
      
       <div class="txt-box">
        <div class="txt">报送人员</div>
        <div class="txt-two">
         {{itemData.submitName}}
        </div>
      </div>
       <div class="txt-box">
        <div class="txt">报送时间</div>
        <div class="txt-two">
          {{itemData.submitTime}}
        </div>
      </div>
       <div class="txt-box">
        <div class="txt">来源栏目</div>
        <div class="txt-two">
         {{itemData.sourceParentsName}}
        </div>
      </div>
       <div class="txt-box">
        <div class="txt">推送栏目</div>
        <div class="txt-two">
         {{itemData.pushParentsName}}
        </div>
      </div>
    </div>
     <div>
        <div class="title">
          <div class="icon-title"></div>
          <div class="title-txt">采纳信息</div>
        </div>
        <div class="txt-box">
        <div class="txt">采纳状态</div>
        <div class="txt-two">
            {{itemData.adoptState==1?'待采纳':itemData.adoptState==2?'已采纳':"未采纳"}}
        </div>
      </div>
        <div class="txt-box">
        <div class="txt">采纳方式</div>
        <div class="txt-two">{{itemData.adoptType==1?'原文采纳':itemData.adoptType==2?'修改采纳':itemData.adoptType==3?'不采纳':''}}</div>
      </div>
      
       <div class="txt-box">
        <div class="txt">采纳人员</div>
        <div class="txt-two">
        {{itemData.adoptName}}
        </div>
      </div>
       <div class="txt-box">
        <div class="txt">采纳时间</div>
        <div class="txt-two">
          {{itemData.adoptTime}}
        </div>
      </div>
       <div class="txt-box">
        <div class="txt">采纳分值</div>
        <div class="txt-two">
          +{{itemData.number}}分（{{itemData.scoringName}}）
        </div>
      </div>
       <div class="txt-box">
        <div class="txt">加分组织</div>
        <div class="txt-two">
          {{itemData.organName}}
        </div>
      </div>
    </div>
    </div>
  </a-spin>
    </el-drawer>
  </div>
</template>

<script>
import {details} from './component'
export default {
  data() {
    return {
      visibleTwo: false,
      appLoading: false,
      itemData:{},
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    item:{
      type:Object,
      default:{},
    }
  },
  components: {},
  mounted() {},
  methods: {
    closeTwo() {
      this.$emit('closeTwo')
    },
    deils(){
      this.appLoading = true;
      details({
        id:this.item.id,
      }).then((res)=>{
          if(res.code == 0){
              this.itemData = res.data;
              this.appLoading = false;
          }
      })
    }
  },
  created() {},
  watch: {
    visible(val) {
      this.visibleTwo = val;
      if(this.visibleTwo){
        this.deils();
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-drawer__header {
  border-bottom: solid 1px #ededef;
  padding-bottom: 10px;
  padding-top: 10px;
  color: #000;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 14px;
}
.el-drawer__close-btn {
  font-size: 14px;
}
/deep/ .el-drawer {
  border-top-left-radius: 13px;
  border-bottom-left-radius: 13px;
}
/deep/ .el-icon-close {
  font-weight: 600;
}
.applay-box {
  padding: 24px;
  padding-bottom: 20px;
  padding-top: 0px;
  padding-bottom: 100px;
}
.title {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .icon-title {
    width: 4px;
    height: 18px;
    border-radius: 2px;
    background-color: rgba(23, 109, 230, 1);
  }
  .title-txt {
    color: rgba(23, 109, 230, 1);
    font-size: 16px;
    font-family: HarmonyOS_Sans_SC-regular;
    margin-left: 10px;
    font-weight: 600;
  }
}
.txt {
  color: rgba(48, 49, 51, 1);
  font-size: 14px;
  font-family: HarmonyOS_Sans_SC-bold;
  font-weight: 600;
  width: 80px;
}
.txt-two {
  color: rgba(48, 49, 51, 1);
  font-size: 14px;
  font-family: HarmonyOS_Sans_SC-regular;
  width: 100%;
}
.txt-box {
  margin-bottom: 20px;
  display: flex;
}
.txt-two-img {
  width: 90px;
  height: 90px;
  margin-right: 14px;
  background: #f6f6f6;
  /deep/ .el-image__inner {
    object-fit: contain;
  }
}
/deep/ .el-descriptions--medium.is-bordered .el-descriptions-item__cell {
  padding: 8px;
  &:first-child {
    width: 120px;
  }
}
.label-box {
  width: 300px;
}
</style>